export default "https://cdn-static.gokick.com/assets/7e8bc23aa9277111cd73fa77d581d1f801b67d5a/images/fruit-punch-flavor.889508fe874ef64cfa80393c89a02614.png";